import React, { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import {
  SectionContent,
  SectionGroup,
  SectionHeader,
  SectionItem,
  SectionTitle,
  SectionItemValue,
} from '@/components/ui'
import { useSimulacaoContentContext } from '@/features/simulador/brasil/context/simulacao-content.context'
import { StringUtils } from '@/utils'

import { createEmpreendimentoSectionItems } from './empreendimento-section-factory'

export const EmpreendimentoSection = () => {
  const { t } = useTranslation('simulacao')
  const { simulacao } = useSimulacaoContentContext()

  const { empreendimentoItems, detailItems } = useMemo(() => createEmpreendimentoSectionItems(simulacao), [simulacao])

  return (
    <React.Fragment>
      <SectionHeader>
        <SectionTitle>{t('pages.simulacao.empreendimento.titulo')}</SectionTitle>
      </SectionHeader>
      <SectionContent>
        <SectionGroup withBorder>
          <SectionItem label={t('pages.simulacao.empreendimento.cliente')}>
            <SectionItemValue>{StringUtils.capitalize(simulacao.cliente.nome)}</SectionItemValue>
          </SectionItem>
        </SectionGroup>

        <SectionGroup withBorder>
          {empreendimentoItems.map((item) => (
            <SectionItem
              key={item.label}
              label={item.label}
              colSpan={item.colSpan}
              withRightBorder={item.withRightBorder}
            >
              <SectionItemValue>{item.value}</SectionItemValue>
            </SectionItem>
          ))}
        </SectionGroup>

        <SectionGroup>
          {detailItems.map((item) => (
            <SectionItem
              key={item.label}
              label={item.label}
              colSpan={item.colSpan}
              withRightBorder={item.withRightBorder}
            >
              <SectionItemValue>{item.value}</SectionItemValue>
            </SectionItem>
          ))}
        </SectionGroup>
      </SectionContent>
    </React.Fragment>
  )
}
